import { appStore, TABS, type TabId } from '../store/app';

/**
 * Hash usmerjanje za zavihke (D3, vprašanje 10 — odločeno 2026-07-19).
 *
 * Neznan hash pusti zavihek pri miru in URL-ja ne prepiše: skok na
 * vsebino (#screen) ne sme pomeniti menjave zaslona.
 */

function isTabId(value: string): value is TabId {
  return (TABS as readonly string[]).includes(value);
}

function tabFromLocation(): TabId | null {
  const raw = location.hash.replace(/^#/, '');
  return isTabId(raw) ? raw : null;
}

export function navigate(tab: TabId): void {
  if (location.hash === `#${tab}`) return;
  location.hash = tab;
}

export function startRouter(): void {
  const initial = tabFromLocation();
  if (initial === null) {
    history.replaceState(null, '', `#${appStore.get().tab}`);
  } else {
    appStore.set({ tab: initial });
  }

  window.addEventListener('hashchange', () => {
    const tab = tabFromLocation();
    if (tab !== null) appStore.set({ tab });
  });
}
